export default __webpack_public_path__ + "static/media/mobile_6.ea5b6bce.png";